import React, { useContext } from 'react';
import { Box, Link, Typography } from '@mui/material';
import { SectionPaper } from '../SectionPaper';
import { FormDataContext } from '../../contexts/FormDataContext';
import { PrivacyModal } from '../PrivacyModal';

export const SubmitComplete = () => {
  const {
    isFormCompleted,
  } = useContext(FormDataContext);
  return (
    <>
      {isFormCompleted
        ?
          <Box textAlign="center">
            <Typography
              variant="h2"
              component="h2"
              sx={{marginTop: '40px', marginBottom: '25px'}}
            >
              Your preferences have been updated!
            </Typography>
            <SectionPaper sx={{padding: '25px'}}>
              <Typography sx={{marginBottom: '10px'}}>
                <Link href='/'>Click here to return to your account and preferences form.</Link>
              </Typography>
            </SectionPaper>
          </Box>
        :
          <>
            <PrivacyModal/>
            <Box textAlign="center">
              <Typography
                variant="h2"
                component="h2"
                sx={{marginTop: '40px', marginBottom: '25px'}}
              >
                Thank you for signing up!
              </Typography>
              <SectionPaper sx={{padding: '25px'}}>
                <Typography sx={{marginBottom: '10px'}}>
                  You will receive an email from us shortly with your account details.
                </Typography>
                <Typography sx={{marginBottom: '10px'}}>
                  Click <Link href="https://afciviliancareers.com/find-a-job/">here</Link> to see all available job opportunities with AFCS.
                </Typography>
                <Typography sx={{marginBottom: '10px'}}>
                  (If you do not receive the email, please check your spam filter and add <Link href="https://afciviliancareers.com/">afciviliancareers.com</Link> to the permitted list.)
                </Typography>
                <Typography>
                  Thank you!
                </Typography>
              </SectionPaper>
            </Box>
          </>
      }

    </>
  )
}